<template>
    <div class="py-3 py-lg-4  col-12">
        <div class="col-12 col-md-10 col-lg-9 row mx-auto justify-content-between px-0" v-if="bonuses">
            <h4 class="w-100 text-center text-white my-3 my-lg-5 page-main-title">
                Бонусы VIP Magnit
            </h4>

            <div class="row mx-0 w-100 justify-content-center">
                <div class="col-12 col-md-4 mb-5" v-for="(bonus, index) in bonuses" :key="index"
                     v-lazy-container="{ selector: 'img', loading: loader }">

                    <div class="row mx-0 w-100">
                        <img :src="getIcon(bonus.image)" :data-src="getIcon(bonus.image)"
                             :alt="'Casino VipMagnit онлайн Казино : '+ bonus.title"
                             class="bonus-icon m-auto">
                    </div>
                    <div class="row mx-0 my-3 w-100">
                        <p class="bonus-title mx-auto">{{bonus.title}}</p>
                    </div>
                    <div class="row mx-0 w-100">
                        <button class="main-btn btn bonus-btn px-5 mx-auto cursor-pointer"
                                @click="openBonusModal(bonuses[index])">
                            Подробнее
                        </button>
                    </div>
                </div>
            </div>

            <b-modal
                    id="bonusModal"
                    ref="bonusModal"
                    :title="selectedBonus ? selectedBonus.title : ''"
                    size="lg"
                    :hide-footer="true"
                    modal-class="main-modal main-block"
                    header-class="text-white border-0"
                    header-close-variant="orange"
                    title-class="text-center underlined-muted-title my-4 mx-auto"
                    body-class="pt-0"
                    @cancel="closeBonusModal"
                    @esc="closeBonusModal"
                    @backdrop="closeBonusModal"
                    @headerclose="closeBonusModal">
                <div v-if="selectedBonus" v-html="selectedBonus.description"></div>
            </b-modal>
        </div>
    </div>
</template>

<script>

  import Config from "@/config";

  export default {
    data() {
      return {
        loader: require('@/../public/images/icons/main-loader.svg'),
        selectedBonus: null
      }
    },
    computed: {
      bonuses() {
        return this.$store.getters['getActiveBonuses']
      }
    },
    methods: {
      getIcon(icon) {
        return Config.mainStorageUrl + icon
      },
      openBonusModal(bonus) {
        this.selectedBonus = bonus
        this.$refs.bonusModal.show()
      },
      closeBonusModal() {
        this.$refs.bonusModal.hide()
        this.selectedBonus = null
      }
    },
    mounted(){
      this.$store.dispatch("fetchBonuses")
    }
  }
</script>

<style scoped>
    .bonus-icon {
        width: 100%;
        max-width: 250px;
        object-fit: cover;
        transition: transform .5s;
    }

    .bonus-icon:hover {
        transform: rotate(360deg);
    }

    .bonus-title {
        color: white;
        text-transform: uppercase;
    }
</style>
